import RadioButton from '../atoms/RadioButton';
import { PaymentProvider, PaymentType } from '../../models/payment';

interface PaymentProviderOptionProps {
  provider: PaymentProvider;
  label: string;
  description: string;
  selectedProvider: PaymentProvider | null;
  disabled?: boolean;
  onSelect: (provider: PaymentProvider, method: PaymentType) => void;
}

/**
 * PaymentProviderOption - Single payment provider radio option
 *
 * Theme Support: ✅ Full light/dark mode support
 * Colors Used: text-text-secondary for description
 */
const PaymentProviderOption: React.FC<PaymentProviderOptionProps> = ({
  provider,
  label,
  description,
  selectedProvider,
  disabled = false,
  onSelect,
}) => (
  <div className="flex flex-col">
    <RadioButton
      name="paymentProvider"
      value={provider}
      checked={selectedProvider === provider}
      label={label}
      disabled={disabled}
      onChange={() => onSelect(provider, PaymentType.ONLINE)}
    />
    <span className="text-xs text-text-secondary ml-7">{description}</span>
  </div>
);

export default PaymentProviderOption;
